<template>
  <div class="main-container">
    <div class="container">
      <div v-for="(alif, index) in alifs" :key="index">
        <p>{{ alif }}</p>
        <div
          v-if="index === 20 || index === 41 || index === 62"
          style="width: 100%; height: 100px;borer-top: 1px solid #000;"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AlifKasra",
  data() {
    return {
      alifs: "اَ اِ اُ بَ بِ بُ تَ تِ تُ جَ جِ جُ حَ حِ حُ خَ خِ خُ دَ دِ دُ ذَ ذِ ذُ رَ رِ رُ زَ زِ زُ سَ سِ سُ شَ شِ شُ صَ صِ صُ ضَ ضِ ضُ طَ طِ طُ ظَ ظِ ظُ عَ عِ عُ غَ غِ غُ فَ فِ فُ قَ قِ قُ كَ كِ كُ لَ لِ لُ مَ مِ مُ نَ نِ نُ وَ وِ وُ ﻫَ ﻫِ ﻫُ يَ يِ يُ".split(
        " "
      ),
    };
  },
};
</script>
<style scoped>
html {
  height: 100% !important;
}
body {
  margin: 0;
  padding: 0;
}
.main-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.container {
  max-width: 100%;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  direction: rtl;
}

.container p {
  margin: 0;
  padding: 0;
  font-size: 102px;
  width: 200px;
  padding: 25px 0;
  line-height: 88px;
  text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, 1);
}

@media print {
  p {
    text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    color: rgba(255, 255, 255, 1);
  }

  @media print and (-webkit-min-device-pixel-ratio: 0) {
    p {
      color: rgba(255, 255, 255, 1);
      -webkit-print-color-adjust: exact;
      text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    }
  }
}
</style>
